export const PROJECT_VERSIONS = {
  // VersionNode elements
  VERSION_NODE_MORE_MENU_BUTTON: 'project-versions-version-node-more-menu-button',
  // VersionNodeTag elements
  EDIT_TAG_BUTTON: 'project-versions-edit-tag-button',
  ADD_TAG_BUTTON: 'project-versions-add-tag-button',
  TAG_DROPDOWN_LIST: 'project-versions-tag-dropdown-list',

  // VersionNodeMoreMenu elements
  MORE_MENU_BUTTON: 'project-versions-more-menu-button',
  OPEN_VERSION_MENU_ITEM: 'project-versions-open-version-menu-item',
  CREATE_VERSION_MENU_ITEM: 'project-versions-create-version-menu-item',
  ASSIGN_BASELINE_MENU_ITEM: 'project-versions-assign-baseline-menu-item',
  REMOVE_BASELINE_MENU_ITEM: 'project-versions-remove-baseline-menu-item',
  MAKE_DEFAULT_MENU_ITEM: 'project-versions-make-default-menu-item',
  MAKE_READ_ONLY_MENU_ITEM: 'project-versions-make-read-only-menu-item',
  MAKE_EDITABLE_MENU_ITEM: 'project-versions-make-editable-menu-item',
  RENAME_VERSION_MENU_ITEM: 'project-versions-rename-version-menu-item',
  DELETE_VERSION_MENU_ITEM: 'project-versions-delete-version-menu-item',

  // DeleteVersionDialog elements
  DELETE_DIALOG_CLOSE_BUTTON: 'project-versions-delete-dialog-close-button',
  DELETE_DIALOG_CANCEL_BUTTON: 'project-versions-delete-dialog-cancel-button',
  DELETE_DIALOG_DELETE_BUTTON: 'project-versions-delete-dialog-delete-button',

  // VersionsDialog elements
  VERSIONS_DIALOG_CLOSE_BUTTON: 'project-versions-dialog-close-button',
  FILTER_BUTTON: 'project-versions-filter-button',
  BACK_BUTTON: 'project-versions-back-button',

  // VersionsDropdown elements
  DROPDOWN_BUTTON: 'project-versions-dropdown-button',
  VERSION_MENU_BUTTON: 'project-versions-version-menu-button',

  // ImportNode elements
  IMPORT_NODE_BUTTON: 'project-versions-import-node-button',

  // TempVersionNode elements
  TEMP_CANCEL_BUTTON: 'project-versions-temp-cancel-button',
  TEMP_CREATE_BUTTON: 'project-versions-temp-create-button',
  TEMP_NAME_INPUT: 'project-versions-temp-name-input',
  TEMP_DESCRIPTION_INPUT: 'project-versions-temp-description-input',

  // VersionNodeTag elements
  TAG_BUTTON: 'project-versions-tag-button',
  TAG_OPTION_ITEM: 'project-versions-tag-option-item',
  TAG_MANAGE_BUTTON: 'project-versions-tag-manage-button',

  // VersionCanvasTagsDialog elements
  TAGS_DIALOG_CLOSE_BUTTON: 'project-versions-tags-dialog-close-button',
  TAGS_DIALOG_CANCEL_BUTTON: 'project-versions-tags-dialog-cancel-button',
  TAGS_DIALOG_SAVE_BUTTON: 'project-versions-tags-dialog-save-button',
  TAG_NAME_INPUT: 'project-versions-tag-name-input',
  TAG_OPTION_INPUT: 'project-versions-tag-option-input',
  TAG_COLOR_PICKER: 'project-versions-tag-color-picker',
  TAG_DELETE_BUTTON: 'project-versions-tag-delete-button',
  TAG_ADD_OPTION_BUTTON: 'project-versions-tag-add-option-button'
} as const;
